import actionTypes from '../actionTypes';

const initialState = {
  publishers: [],
  status: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PUBLISHERS_GET_REQUEST:
    case actionTypes.PUBLISHER_GET_REQUEST:
    case actionTypes.PUBLISHER_CREATE_REQUEST:
    case actionTypes.PUBLISHER_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.PUBLISHERS_GET_ERROR:
      return { ...state, status: action.type, publishers: [] };

    case actionTypes.PUBLISHERS_GET_SUCCESS:
      return { ...state, status: action.type, publishers: action.publishers };

    case actionTypes.PUBLISHER_GET_ERROR:
    case actionTypes.PUBLISHER_CREATE_ERROR:
      return { ...state, status: action.type, error: action.error };

    case actionTypes.PUBLISHER_GET_SUCCESS:
    case actionTypes.PUBLISHER_SELECT:
      return { ...state, status: action.type };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/publishers.js